<mat-button-toggle-group
  [id]="field.attributes.id"
  [value]="value"
  (change)="value = $event.value"
  [disabled]="disabled"
  [hideSingleSelectionIndicator]="true"
  appearance="legacy"
>
  @for (option of options; track option) {
  <mat-button-toggle [value]="option.id">
    {{ option.value }}
  </mat-button-toggle>
  }
</mat-button-toggle-group>
